/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Original_PlaceholderInputs */

const en_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an audio or video file...`)
};

const fr_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un fichier audio ou vidéo...`)
};

const de_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Audio- oder Videodatei aus...`)
};

const it_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un file audio o video...`)
};

const ru_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите аудио- или видеофайл...`)
};

const es_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un archivo de audio o vídeo...`)
};

const zh_cn2_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择音频或视频文件……`)
};

const ja_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声ファイルまたは動画ファイルを選択してください...`)
};

const hi_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक ऑडियो या वीडियो फ़ाइल चुनें...`)
};

const pt_pt2_audio_embed_export_original_placeholder = /** @type {(inputs: Audio_Embed_Export_Original_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um arquivo de áudio ou vídeo...`)
};

/**
* | output |
* | --- |
* | "Select an audio or video file..." |
*
* @param {Audio_Embed_Export_Original_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_original_placeholder = /** @type {((inputs?: Audio_Embed_Export_Original_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Original_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_original_placeholder(inputs)
	if (locale === "de") return de_audio_embed_export_original_placeholder(inputs)
	if (locale === "it") return it_audio_embed_export_original_placeholder(inputs)
	if (locale === "ru") return ru_audio_embed_export_original_placeholder(inputs)
	if (locale === "es") return es_audio_embed_export_original_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_original_placeholder(inputs)
	if (locale === "ja") return ja_audio_embed_export_original_placeholder(inputs)
	if (locale === "hi") return hi_audio_embed_export_original_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_original_placeholder(inputs)
	return en_audio_embed_export_original_placeholder(inputs)
});